import React, { useState } from 'react'
import './Info.css';

const Info = ( {post, setModal} ) => {

  // console.log(post,"Posts");

  return (
    <div className='card-content'>
        <p>{post.name}</p>
        <p>{"Age: " + post.age}</p>
        <p>{"Position: " + post.position}</p>
            <button onClick={()=> setModal(false)} type="button" class="btn btn-danger">Close</button>
  </div>                                            
  
  
  )
}

export default Info